var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 33,
    viewBox: "0 0 50 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8862 39.2545C18.3992 39.0487 9.03534 38.6092 7.37314 38.4993C5.30738 38.3634 3.51732 34.2379 3.40144 29.6269C3.18568 20.9803 3.01786 12.2377 7.39312 8.33796C12.082 4.15649 16.5192 3.61308 24.4466 3.68101C31.1774 3.73695 38.1917 4.47015 42.4152 9.59061C45.9234 13.842 45.6856 23.2079 45.1862 28.4102C44.5888 34.6275 43.3801 39.0027 41.1825 39.1686C38.9849 39.3324 32.6737 39.5022 24.8862 39.2545Z",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4463 3.75901C28.4463 3.75901 29.8987 2.76009 30.1145 2.09681C30.3302 1.43353 30.2284 1 30.2284 1",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8184 3.64669C29.8184 3.64669 30.2998 3.04135 31.2188 2.46198C31.6943 2.1623 32.2677 2.06641 32.2677 2.06641",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1191 13.1797L49.0005 13.8649",
    stroke: "black",
    strokeWidth: 0.998918,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5752 11.1797L23.8531 13.1775",
    stroke: "black",
    strokeWidth: 0.998918,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2709 13.8398L47.7655 22.4345L29.0078 21.5055",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.389 20.9771L1 19.8363L1.57538 11.1797",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6207 13.621C14.4688 14.5679 13.0983 15.469 11.506 15.3251C9.91377 15.1813 8.76302 14.0525 8.85692 13.0975C9.01675 11.4633 10.3673 11.769 11.9596 11.9148C13.5518 12.0607 14.8744 12.0387 14.6207 13.621Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.15 14.9491C40.9981 15.8961 39.6276 16.7971 38.0353 16.6532C36.4431 16.5094 35.2923 15.3806 35.3862 14.4257C35.546 12.7914 36.8966 13.0971 38.4889 13.2429C40.0791 13.3868 41.4057 13.3668 41.15 14.9491Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8466 16.8759C25.0854 16.732 23.8208 16.6801 22.7979 16.9877C21.9828 17.2315 21.4873 17.701 21.4873 17.701C22.702 22.248 24.6978 23.2649 24.6978 23.2649C24.6978 23.2649 28.1181 20.9794 27.8984 18.1405",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.200948daa3c3bbd395bedd31ad463bf8.svg";
export { ForwardRef as ReactComponent };